import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchResultsComponent } from '../../search-results/search-results.component';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../../service/util.service';
import { ApiService } from '../../service/api.service';
import { AuthenticationService } from '../../service/authentication.service';
import { ToastService } from '../../service/toast.service';
import { SearchDataService } from '../../service/search-data.service';
import { Constants } from '../../constants/constants';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-dongle-provider-detail',
  templateUrl: './dongle-provider-detail.component.html',
  styleUrls: ['./dongle-provider-detail.component.scss']
})
export class DongleProviderDetailComponent implements OnInit {


  isViewScreen = false;
  provider : any = {};
  providerAdministrator : any = [];

  inviteProviderAdminModal;
  @ViewChild('inviteProviderAdminForm', { static: true }) public inviteProviderAdminForm: NgForm;
  
  //Search result storage variable
  @ViewChild('searchResult') searchResult: SearchResultsComponent;
  searchedVehicleList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;
  isSearchResult: boolean = false;

  isViewProviderAdmin: boolean = false;
  selectedProviderAdmin: any;

  constructor(private route: ActivatedRoute, public utilService: UtilService, private apiService: ApiService, public authService: AuthenticationService, private toastService: ToastService, private searchService: SearchDataService) { }

  ngOnInit() {
    this.isViewScreen = false;
    // this.route.queryParamMap.subscribe(queryParams => {
    //   this.isSearchResult = JSON.parse(queryParams.get("isSearchResult"));
    // })

    this.getProviderDetail();
    this.getProviderAdmin();
    this.initInviteProviderAdminModal();
  }

  getProviderDetail() {

    this.utilService.showSpinner();
    this.apiService.getDongleProviderDetail().then((data) => {
      this.utilService.hideSpinner();
      this.provider = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getProviderDetail();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });

  }

  getProviderAdmin() {

    this.utilService.showSpinner();
    this.apiService.getDongleProviderUser().then((data) => {
      this.utilService.hideSpinner();
      this.providerAdministrator = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getProviderAdmin();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });

  }

  providerAdminClicked(admin) {
    // console.log("VALUE IS:", admin);
    // this.isViewProviderAdmin = true;
    // this.selectedProviderAdmin = admin;
  }

  closeOfProviderAdminClicked(data) {
    this.isViewProviderAdmin = false;
  }

  
  initInviteProviderAdminModal() {
    this.inviteProviderAdminModal = [
      {
        "name": null,
        "phone": null,
        "username": null,
        "roles": ["ROLE_DONGLE_PROVIDER_ADMIN"],
        "gender": "Male",
        "enterpriseId": null,
        "providerId": null,
        "image": null
      }
    ];
  }

  resetInviteProviderAdminForm() {
    if (this.inviteProviderAdminForm) {
      this.inviteProviderAdminForm.reset();
      this.inviteProviderAdminForm.resetForm();
      this.initInviteProviderAdminModal();
    }
  }

  changeUploadUserLogoClicked() {
    document.getElementById("uploadUserLogo").click();
  }

  uploadUserImage(event) {

    console.log("Upload started");

    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('file', file, file.name);
      formData.append('folder', 'user/' + this.provider.id);

      this.utilService.showSpinner();
      this.apiService.uploadFleetLogo(formData).then((data) => {
        this.utilService.hideSpinner();
        console.log("Response is :: ", data);
        this.inviteProviderAdminModal[0].image = data.imageUrl;
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.uploadUserImage(event);
          });
        }
        else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
          else this.toastService.showError(Constants.UNKNOWN_ERROR);
        }
      });
    }
  }

  inviteAdminSubmit(form: NgForm) {
    this.inviteProviderAdminForm = form;
    if (form.valid) {

      this.inviteProviderAdminModal[0].enterpriseId = this.authService.loggedInUser.enterpriseId;
      this.inviteProviderAdminModal[0].providerId = this.provider.id;

      console.log("form submited : ", this.inviteProviderAdminModal);

      this.utilService.showSpinner();
      this.apiService.inviteDongleProviderUser(this.inviteProviderAdminModal).then((data) => {
        this.utilService.hideSpinner();
        this.resetInviteProviderAdminForm();
        this.getProviderAdmin();
        this.toastService.showSuccess("User created successfully");
        document.getElementById("closeInviteAdminModel").click();
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.inviteAdminSubmit(form);
          });
        }
        else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
          else this.toastService.showError(Constants.UNKNOWN_ERROR);
        }
      });
    }
  }
}
